// noinspection ES6ConvertVarToLetConst

// <div ng-controller="ExampleCtrl as exCtrl">
//   <span>{{ exCtrl.myVar }}</span>
//   <span>{{ exCtrl.myFunc() }}</span>
// </div>

// no script tag in head is needed, this should immediately start working if you are running ./gradlew gulp_watch

var ExampleCtrl = function ($scope) {
    'use strict'

    $scope.myVar = 'hello'

    $scope.myFunc = function () {
        return null
    }

    return $scope
}

ExampleCtrl.$inject = ['$scope']
angular.module('app').controller('ExampleCtrl', ExampleCtrl); // one semi at end of file is a must or lots of things break!
